
import { Injectable } from '@angular/core';
import { AppConfiguration } from '@config/app-configuration';


declare const cxone: any;


@Injectable({
  providedIn: 'root'
})
export class CxoneService {
  private isInitialized: boolean = false;

  constructor(private appConfig: AppConfiguration) { }

  /**
   * Initialize CXone chat widget
   * This should only be called after user is authenticated
   */
    public initialize(): void {
        if (this.isInitialized) {
            return; // Already initialized
        }


    // Check if script already exists
    const existingScript = document.querySelector('script[src*="niceincontact.com/loader"]');
    if (existingScript && typeof cxone !== 'undefined') {
      // Script already loaded, just initialize
      this.initCxone();
      return;
    }

    // Load the CXone script dynamically
    this.loadCxoneScript();
    // Initialize immediately - cxone function queues calls until script loads
    this.initCxone();
  }


  /**
   * Load CXone script dynamically
   */
  private loadCxoneScript(): void {
    // Check if script already exists
    const existingScript = document.querySelector('script[src*="niceincontact.com/loader"]');
    if (existingScript) {
      return;
    }

    // Initialize the CXone loader (matches original pattern)
    (function (n: string, u: string) {
      (window as any).CXoneDfo = n;
      (window as any)[n] = (window as any)[n] || function () {
        ((window as any)[n].q = (window as any)[n].q || []).push(arguments);
      };
      (window as any)[n].u = u;
      const e = document.createElement('script');
      e.type = 'module';
      e.src = u + '?' + Math.round(Date.now() / 1e3 / 3600);
      document.head.appendChild(e);
    })('cxone', this.appConfig.cxoneLoaderUrl);
  }


  /**
   * Initialize CXone with configuration
   */
  private initCxone(): void {
    try {


      let externalSVAID = '';
      let programName = '';
      const dataStr = localStorage.getItem('data');
      if (dataStr) {
        try {
          const data = JSON.parse(dataStr);
          const cards = data?.Cards || [];
          if (cards.length > 0 && cards[0].ExternalSVAID) {
            externalSVAID = cards[0].ExternalSVAID;
            programName = cards[0].ProgramName;
          }
        } catch (e) {
          console.error('Error parsing post-login data for ExternalSVAID', e);
        }
      }

      // The cxone function queues calls if script hasn't loaded yet
      if (typeof (window as any).cxone !== 'undefined') {
        (window as any).cxone('init', this.appConfig.cxoneBrandId);
        (window as any).cxone('guide', 'init', this.appConfig.cxoneGuideId);
        (window as any).cxone('guide', 'setCustomCss', '\n'); 
        (window as any).cxone('chat', 'setCaseCustomField', 'prn', externalSVAID);
        (window as any).cxone('chat', 'setCaseCustomField', 'programName', programName);

        this.isInitialized = true;
      } else {
        // If cxone doesn't exist yet, set it up and queue the calls
        (window as any).cxone = (window as any).cxone || function () {
          ((window as any).cxone.q = (window as any).cxone.q || []).push(arguments);
        };
        (window as any).cxone('init', this.appConfig.cxoneBrandId);
        (window as any).cxone('guide', 'init', this.appConfig.cxoneGuideId);
        (window as any).cxone('guide', 'setCustomCss', '\n');
        (window as any).cxone('chat', 'setCaseCustomField', 'prn', externalSVAID);
        (window as any).cxone('chat', 'setCaseCustomField', 'programName', programName);
      

        this.isInitialized = true;
      }
    } catch (error) {
      console.error('Error initializing CXone:', error);
    }
  }


  /**
   * Destroy/Cleanup CXone (e.g., on logout)
   */
  public destroy(): void {
    // CXone doesn't have a standard destroy method, but we can mark as not initialized
    // The widget will remain but won't re-initialize
    this.isInitialized = false;
  }
}











